import { ManageElement } from "./ManageElement";
import { CutSizeStore } from "stores/CutSizeStore";

export class CutSize extends ManageElement {
  static _store: CutSizeStore;
}
